import { render, staticRenderFns } from "./StarshipsVentures.vue?vue&type=template&id=ffb55dfa&lang=pug&"
import script from "./StarshipsVentures.vue?vue&type=script&lang=ts&"
export * from "./StarshipsVentures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports